import clsx from 'clsx';
import { Icon, Referenz } from 'components/atoms';
import React, { memo, useEffect, useState } from 'react';
import type { NetzwerkDto } from 'types';
import { Referenz as ReferenzType } from 'types';
import { usePlusPage, useTranslation, useWindowSize } from 'utils/hooks';

import Watermark from '../../atoms/Watermark/Watermark';

import Anteil from './Anteil';
import css from './Beteiligungen.module.scss';

type LargeItems = {
  gesellschafter: number;
  beteiligungen: number;
};

export interface BeteiligungsProps
{
  netzwerk: NetzwerkDto;
  origin: ReferenzType;
}

const Beteiligung: React.FC<BeteiligungsProps> = (props) =>
{
  const { origin, netzwerk } = props;
  const { t } = useTranslation(['profiles', 'formats']);
  const { width } = useWindowSize();
  const isPlusPage = usePlusPage();

  const [largeItems, setLargeItems] = useState<LargeItems>({ gesellschafter: 0, beteiligungen: 0 });
  
  const gesellschafter = [...netzwerk.gesellschafter];
  const beteiligungen = [...netzwerk.beteiligungen];

  useEffect(() =>
  {
    const largeGesellschafter = Array.from(document.querySelectorAll('#gesellschafter-graph > li'))
      .reduce<number>((count, li) => getComputedStyle(li).position === 'absolute' ? count + 1 : count, 0);

    const largeBeteiligungen = Array.from(document.querySelectorAll('#beteiligungen-graph > li'))
      .reduce<number>((count, li) => getComputedStyle(li).position === 'absolute' ? count + 1 : count, 0);
    
    setLargeItems({ gesellschafter: largeGesellschafter, beteiligungen: largeBeteiligungen });
  }, [width, netzwerk]);

  return (
    <div>
      <div className={css.graphContainer}>
        
        {/* Gesellschafter */}
        {gesellschafter.length > 0 && (
          <div className={clsx(css.graph, css.gesellschafter, css[`exactly-${gesellschafter.length}-items`])}>
            <ol id="gesellschafter-graph" className={clsx('scrollbars', css.list)}>
              {gesellschafter.map((g) => <Anteil key={g.key} item={g} />)}
            </ol>
            <span className={css.label}>{t('profiles:beteiligungen.parents')}</span>
            {largeItems.gesellschafter > 0 && largeItems.gesellschafter < gesellschafter.length && (
              <span className={css.more}>
                {t('profiles:beteiligungen.more', { count: gesellschafter.length - largeItems.gesellschafter })}
              </span>
            )}
          </div>
        )}


        {/* Origin */}
        <Referenz data={origin}>
            {({ iconName }) => (
                <div className={css.originRow}>
                  {!isPlusPage && <Watermark />}
                  <div className={css.origin}>
                    <Icon name={iconName}/>
                    <span>{origin.name}</span>
                  </div>
                  {!isPlusPage && <Watermark />}
                </div>
            )}
        </Referenz>

        {/* Beteiligungen */}
        {beteiligungen.length > 0 && (
          <div className={clsx(css.graph, css.beteiligungen, css[`exactly-${beteiligungen.length}-items`])}>
            <ol id="beteiligungen-graph" className={clsx('scrollbars', css.list)}>
              {beteiligungen.map((b) => <Anteil key={b.key} item={b} /> )}
            </ol>
            <span className={css.label}>{t('profiles:beteiligungen.children')}</span>
            {largeItems.beteiligungen > 0 && largeItems.beteiligungen < beteiligungen.length && (
              <span className={css.more}>
                {t('profiles:beteiligungen.more', { count: beteiligungen.length - largeItems.beteiligungen })}
              </span>
            )}
          </div>
        )}

      </div>
    </div>
  );
};

export default memo(Beteiligung);
